module.exports = __webpack_public_path__ + "img/svg - only background.28081825.svg";